import React, { useEffect, useState } from 'react';
import TokenCostVisualization from './TokenCostVisualization';
import DeploymentCostCalculator from './DeploymentCostCalculator';
import LoggingService from './services/LoggingService';
import './App.css';
import './animations.css';

function App() {
  // Tab selection state (with localStorage)
  const [activeTab, setActiveTab] = useState(() => {
    const saved = localStorage.getItem('activeTab');
    return saved || 'tokens';
  });

  // Save active tab to localStorage
  useEffect(() => {
    localStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  // Log visit when the app loads
  useEffect(() => {
    // Log the visit with basic info
    LoggingService.logVisit({
      pageTitle: document.title,
      referrer: document.referrer || 'Direct',
      appVersion: '1.0.0'
    });
  }, []);
  
  return (
    <div className="App">
      <header className="py-6 bg-gray-100 mb-4">
        <div className="container mx-auto px-4">
          <h1 className="text-2xl md:text-3xl font-bold text-center mb-3">AI-conomics 101: Tokens and Costs</h1>
          <div className="text-center">
            <p className="text-gray-700 mb-1">By <a href="https://www.linkedin.com/in/securelyyours/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 font-medium">Manah Khalil</a></p>
            <p className="text-gray-700 text-sm"><span className="font-medium">The AI Economy Network</span> (AIConomy.net)</p>
          </div>
        </div>
      </header>
      
      <div className="container mx-auto px-4 mb-6 content-block">
        <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-md">
          <h2 className="font-bold text-lg mb-2">Breaking Into GenAI Cost Consulting: A Strategic Guide</h2>
          <p className="mb-3">Most organizations are deploying GenAI without understanding the true cost implications. What starts as a $1,000/month pilot becomes a $50,000/month production expense with no warning.</p>
          <div className="flex items-center">
            <div className="mr-2">
              <a href="https://www.linkedin.com/feed/update/urn:li:activity:7339698251236855809/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 font-medium flex items-center">
                Read the full article
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="container mx-auto px-4 mb-6">
        <div className="flex border-b border-gray-300">
          <button
            onClick={() => setActiveTab('tokens')}
            className={`px-6 py-3 font-semibold transition-colors ${
              activeTab === 'tokens'
                ? 'border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-600 hover:text-blue-600'
            }`}
          >
            📊 Token Economics Calculator
          </button>
          <button
            onClick={() => setActiveTab('deployment')}
            className={`px-6 py-3 font-semibold transition-colors ${
              activeTab === 'deployment'
                ? 'border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-600 hover:text-blue-600'
            }`}
          >
            💰 Deployment Type Recommender
          </button>
        </div>
      </div>

      <div className="calculator-block">
        {activeTab === 'tokens' ? (
          <TokenCostVisualization />
        ) : (
          <DeploymentCostCalculator />
        )}
      </div>
      
      <footer className="py-6 bg-gray-100 mt-8">
        <div className="container mx-auto px-4 text-center text-gray-600 text-sm">
          <p>© 2025 The AI Economy Network (AIConomy.net) | Created by <a href="https://www.linkedin.com/in/securelyyours/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">Manah Khalil</a></p>
        </div>
      </footer>
    </div>
  );
}

export default App;
